import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { ElephantPresetType } from '@aibees/elephant/types';
import { ParsedPreset, SearchBrowseParams } from '@aibees/shared/definition';
import { jsonParse } from '@aibees/shared/utils';
import { useFindSearchItemPath } from './use-find-search-item-path';

export function useExtractMetadataFromSearchQuerySearchCardValue(
  item: ParsedPreset<SearchBrowseParams>
) {
  const type = useSearchTypeFromRoute();
  const isCurrentType = item?.value?.type === type;
  const metadata = item?.metadata ? jsonParse(item.metadata) : undefined;
  const cleanedString = metadata?.url?.startsWith('?')
    ? metadata?.url.slice(1)
    : metadata?.url;
  const [searchKey, searchValue] = cleanedString?.split('=') || ['', ''];

  const searchItemPath = useFindSearchItemPath(
    (item?.type || 'COMPANY') as ElephantPresetType
  );
  const path = item?.type ? `${searchItemPath}${metadata?.url || ''}` : '';

  return { metadata, path, searchKey, searchValue, isCurrentType };
}
